import { makeStyles, Theme } from '@material-ui/core';
import { Styles } from '@material-ui/core/styles/withStyles';

import React from 'react';

type CollapsableCardStyleProps = {
  maxWidth?: string;
};

const collapsableCardStyles: Styles<Theme, CollapsableCardStyleProps> = theme => ({
  collapsableCard: {
    margin: 'auto',
    //marginBottom: '10px',
    maxWidth: ({ maxWidth }) => maxWidth ?? '',
  },
  cardWrapper: {
    width: '100%',
    height: '55px',
    borderRadius: '0px',
  },
  card: {
    display: 'flex',
    height: '100%',
    padding: '0 20px',
  },
  cardContent: {
    width: '90%',
    display: 'flex',
    alignItems: 'center',

    '& > p': {
      fontWeight: '600',
    },
  },
});

const useStyles = makeStyles(collapsableCardStyles);

type CollapsableCardProps = CollapsableCardStyleProps & {
  maxWidth?: string;
};

const CollapsableCardHeader: React.FC<CollapsableCardProps> = ({ children, maxWidth }) => {
  const classes = useStyles({ maxWidth });

  return (
    <div className={classes.collapsableCard}>
      <div className={classes.cardWrapper}>
        <div className={classes.card}>
          <div className={classes.cardContent}>{children}</div>
        </div>
      </div>
    </div>
  );
};

export default CollapsableCardHeader;
